module.exports = __webpack_public_path__ + "static/icon-gone.03b9f06f.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-gone.png
// module id = 287
// module chunks = 2